import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductItemALV1Component } from './product-item-al-v1/product-item-al-v1.component';
import { QuantityStepperModule } from 'abs-ngx-library/src/lib/quantity-stepper';
import { ProductCouponModule } from 'abs-ngx-library/src/lib/product-coupon';
import { AutoReplenishmentALV1Module } from 'abs-ngx-library/src/lib/auto-replenishment-al-v1'


@NgModule({
  declarations: [ProductItemALV1Component],
  exports: [
    ProductItemALV1Component,
  ],
  imports: [
    CommonModule,
    QuantityStepperModule,
    ProductCouponModule,
    AutoReplenishmentALV1Module
  ],
  providers: [
    ProductItemALV1Component
  ]
})
export class ProductItemALV1Module { }
